export default __webpack_public_path__ + "static/media/aiColorinActive.43c42482.svg";